<template>
  <header class="container-fluid">
    <div class="container">
      <div class="row">
        <logo></logo>
        <navigation></navigation>
      </div>
    </div>
  </header>
</template>

<script>
import logo from "./logo/logo.vue";
import navigation from "./nav/nav.vue";

export default {
  components: {
    logo,
    navigation
  },
  created() {
    document.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let header = document.getElementsByTagName("header")[0];
      if (window.pageYOffset > header.offsetHeight) {
        header.classList.add("pin");
      } else {
        header.classList.remove("pin");
      }
    }
  }
};
</script>

<style>
</style>
